import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { environment } from 'environments/environment';
import { Observable } from 'rxjs';
import { first, map } from 'rxjs/operators';

export interface CheckTriage {
	id: number;
	profileId: string;
	professionalId: string;
	alreadyHadTherapy: true;
	mainComplaint: string[];
	pointOfLife?: string;
	therapyHistory?: string;
	reasonsForTherapy?: {
		reasons: string[] | { OTHER: string }[];
	};
}

export interface TriageIds {
	profileId: string;
	professionalId: string;
}

@Injectable()
export class TriageService {
	constructor(@Inject(HttpClient) private http: HttpClient) {}

	checkTriage(params: TriageIds): Observable<CheckTriage> {
		const { profileId, professionalId } = params;
		return this.http
			.get<CheckTriage>(
				`${environment.servicesUrl}/chart/triage/${professionalId}/${profileId}`
			)
			.pipe(
				first(),
				map((triage: CheckTriage): CheckTriage => {
					if (triage.mainComplaint) {
						triage.mainComplaint = JSON.parse(triage.mainComplaint as any);
					}
					return triage;
				})
			);
	}
}
